module.exports = __webpack_public_path__ + "img/Manufacturing&Industry.422c5b98.png";